export const loginRouters = [{
  path: '/login',
  name: 'login',
  component: resolve => require(['@/views/login/login.vue'], resolve),
}, {
  path: '/register',
  name: 'register',
  component: resolve => require(['@/views/login/register.vue'], resolve),
}, {
  path: '/bind/mobile',
  name: 'BindMobile',
  component: resolve => require(['@/views/login/bindMobile.vue'], resolve),
},
// 旧忘记密码/重置密码路由已停用，统一使用 /forgetPwMerge
// {
//     path: '/forgetPw',
//     name: 'forgetPw',
//     component: resolve => require(['@/views/login/forgetPw.vue'], resolve)
// },{
//     path: '/resetPassword',
//     name: 'resetPassword',
//     component: resolve => require(['@/views/login/resetPassword.vue'], resolve)
// },
{
  path: '/forgetPwMerge',
  name: 'forgetPwMerge',
  component: resolve => require(['@/views/login/forgetPwMerge.vue'], resolve),
}];
